import * as React from 'react';
import {Component, deps, inject, observer} from '../lib/component';
import {Loading} from '../components/loading/loading';
import {style} from 'typestyle';
import {center, centerJustified, vertical} from 'csstips';
import {viewHeight} from 'csx';
import {gradientDark} from '../theme/gradient';
import MainWrapper from '../components/main-wrapper';

export interface CampaignPageProps {}

@inject(deps) @observer
export class CampaignPage extends Component<CampaignPageProps> {
  render() {
    return (
      <MainWrapper className={CampaignPage.styles.container}>
        <Loading light={true} />
      </MainWrapper>
    )
  }

  componentWillMount() {
    this.props.controller.ui.setChrome(false);
  }

  componentWillUnmount() {
    this.props.controller.ui.setChrome(true);
  }

  static styles = {
    container: style({
      ...vertical,
      ...center,
      ...centerJustified,
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 99,
      minHeight: viewHeight(80),
      background: gradientDark
    }),
  }
}